export default "__VITE_ASSET__ChpuwSDE__"